import React from 'react';

import { useBalancing } from './balancing-hooks';
import { Divider, Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { PaperCard } from 'components/cards/paper-card';

import { BalancingItem } from './components/balancing-item';

const useStyles = makeStyles((theme: any) => ({
  divider: { backgroundColor: theme.palette.tab.offselected, opacity: 0.5 },
}));

export const Balancing = () => {
  const {
    t,
    loanAmount,
    netFunded,
    lenderCredits,
    paidByOthers,
    lenderCharges,
    loanFunding,
    aggregateAdjustment,
  } = useBalancing();
  const classes = useStyles();

  return (
    <PaperCard title={t('orders:loanFundingTitle')}>
      <Grid container direction="column" spacing={1}>
        <Grid item>
          <BalancingItem title={t('orders:loanAmountTitle')} value={loanAmount} />
        </Grid>
        <Grid item>
          <BalancingItem title={t('orders:netFundedTitle')} value={netFunded} isNegativeIncome />
        </Grid>
        <Grid item>
          <BalancingItem
            title={t('orders:lenderCreditsTitle')}
            value={Math.abs(lenderCredits)}
            isNegativeIncome={lenderCredits > 0}
            isPositiveIncome={lenderCredits <= 0}
          />
        </Grid>
        <Grid item>
          <BalancingItem title={t('orders:paidByOthersTitle')} value={paidByOthers} isPositiveIncome />
        </Grid>
        <Grid item>
          <BalancingItem title={t('orders:lenderChargesTitle')} value={lenderCharges} isPositiveIncome />
        </Grid>
        <Grid item>
          <BalancingItem
            title={t('orders:aggregateAdjustmentTitle')}
            value={aggregateAdjustment}
            isPositiveIncome={aggregateAdjustment >= 0}
          />
        </Grid>
        <Grid item>
          <Divider className={classes.divider} />
        </Grid>
        <Grid item>
          <BalancingItem title={t('orders:loanFundingTitle')} value={loanFunding} />
        </Grid>
      </Grid>
    </PaperCard>
  );
};
